<template>
  <div>
    <div 
      :class="[
        'container',
        {'container--selected': selected}
      ]">
      <img 
        v-if="position.filled"
        :src="position.goalkeeper ? gkIcon : shirtIcon"
        :class="['-position-icon', { 'gk-icon': position.goalkeeper }]"
        :draggable="!position.goalkeeper"
        @dragstart="$emit('update:dragging', position)"
        @dragend="$emit('update:dragging', null)"
        @click.stop="onSelect"
        @contextmenu.prevent
        @touchstart="!position.goalkeeper && $emit('update:dragging', position)"
        @touchmove.stop="!position.goalkeeper && $emit('update:dragging', position)"
        @touchcancel="!position.goalkeeper && $emit('update:dragging', null)"
        @touchend="!position.goalkeeper && $emit('touch-move-ended', $event)"
      />

      <div
        class="shirt-name shirt-text"
        :class="{ 'shirt-text--keeper': position.positionNumber === 1 }">
        {{ position.shirtName }}
      </div>

      <div 
        class="shirt-number shirt-text"
        :class="{ 'shirt-text--keeper': position.positionNumber === 1 }">
        {{ position.shirtNumber }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: Object,
    selected: {
      type: Boolean,
      default: false,
    }
  },

  data: () => {
    return {
      gkIcon: require('@/assets/img/gk.png'),
      shirtIcon: require('@/assets/img/shirt.png')
    };
  },

  methods: {
    onSelect () {
      this.$emit('update:selected-position', this.selected ? null : this.position);
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  text-align: center;
  border: solid 2px transparent;
  padding: 4px;
}

.container--selected {
  background: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
  border-bottom: none;
  border-radius: 8px 8px 0 0;
}

.shirt-number {
  top: 50%;
  transform: translate(-50%, -50%);
}

.shirt-name {
  top: 17%;
  transform: translateX(-50%);
  font-size: 6px;
}

.shirt-text {
  color: navy;
  opacity: 0.87;
  font-weight: bold;
  position: absolute;
  left: 50%;
  pointer-events: none;
  text-transform: uppercase;
}

.shirt-text--keeper {
  color: white;
  opacity: 1;
}

.gk-icon {
  cursor: default;
}

.-position-icon {
  touch-action: none;
}

@media only screen and (min-width: 1400px) {  
  .shirt-name {
    font-size: 7px;
  }
}
</style>
